module.exports = __webpack_public_path__ + "static/media/clouds2.cbce556a.png";